import { render, staticRenderFns } from "./reset-password-dialog-and-button.vue?vue&type=template&id=70160954"
import script from "./reset-password-dialog-and-button.vue?vue&type=script&lang=js"
export * from "./reset-password-dialog-and-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports